import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeLot } from 'src/app/models/TypeLot';
import { biTypologieDto } from 'src/app/models/biTypologieDto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypeLotService {

  PATH_ALL_TYPE_LOT = "/programmes-lots/type-lot/all";
  PATH_ALL_TYPE_BYTYPO = "/programmes-lots/typo-lot/by-type/";

  //https://cloud-ide-extrav-realestate.staging.echonet/user/e77868/http/8182/type-lot/all
  constructor(private readonly http: HttpClient) { }
  
  getAllTypeLot = (): Observable<TypeLot[]> => {
    const url = environment.host.domaine + this.PATH_ALL_TYPE_LOT;
    return this.http.get<TypeLot[]>(url)
  }

 gettypologiebycodeType(code: number): Observable<biTypologieDto[]> {

  const url = environment.host.domaine + this.PATH_ALL_TYPE_BYTYPO;
  return this.http.get<biTypologieDto[]>(url+code)
 }

}
